import { types as t } from 'mobx-state-tree';

export const LocationTranslation = t.model('LocationTranslation', {
  title: t.string,
  language: t.string,
});

export default t.model('Location', {
  id: t.identifierNumber,
  translations: t.array(LocationTranslation),
});
